import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import MolLink from '../Basepage/parts/Menu/MolLink';

interface VersandkostenState extends BasePageState {}
interface VersandkostenModel {
  versand: { alpha2: string; basis: string; kg: string; name: string };
}

export default class VersandkostenAuslandPage extends Basepage<
  VersandkostenState,
  VersandkostenModel
> {
  renderChild(): JSX.Element {
    // Unbekanntes Land (z.B. /versandkosten/undefined): API liefert kein versand
    if (!this.body.versand) {
      return (
        <div id="VersandkostenAuslandPage">
          Für dieses Land sind keine Versandkosten hinterlegt. Eine Übersicht
          finden Sie{' '}
          <a href="https://www.buchbutler.de/versandkosten">hier</a>.
        </div>
      );
    }
    return (
      <div id="VersandkostenAuslandPage">
        Dear Buchbutler customers,
        <br />
        <br />
        please note that we have adjusted our shipping costs. This also applies
        to shipments outside Germany.
        <br />
        In future, you will pay a fixed base price for your destination country
        and additional a price per kilogramm.
        <br />
        In addition, there is a handling fee of €0.75 per shipment.
        <br />
        From the 1st of January 2027 the handling fee will be €0.92 per shipment.
        <br />
        In order to save and optimise shipping costs, we would like to recommend
        that you define a shipping day in your customer account.
        <br />
        <br />
        <MolLink to="/konto/" href="/konto/">
          Please click here to go to your customer account settings.
        </MolLink>
        <br />
        We collect the items for you and ship them on the day of your choice.
        You then only pay the actual shipping costs and the handling fee once a
        week.
        <br />
        <br />
        The postage costs are charged separately and listed on a separate
        invoice.
        <br />
        <br />
        <b>Shipping costs: to {this.body.versand.name}</b>
        <br />
        Base price {this.body.versand.basis} &euro; + {this.body.versand.kg}{' '}
        &euro; per kilogramm
        <br />
        <br />
        Do you have a delivery address in Germany?
        <br />
        The shipping costs for shipments within Germany can be found{' '}
        <a href="https://www.buchbutler.de/versandkosten" target="_blank">
          here
        </a>
        <br />
        <br />
        <hr style={{ borderWidth: '2px' }} />
        Liebe Buchbutler Kundinnen und Kunden, <br /> <br />
        bitte beachten Sie, dass wir unsere Versandkosten angepasst haben.
        <br />
        Das betrifft auch die Sendungen außerhalb Deutschlands. <br />
        Sie zahlen in Zukunft einen fixen Basispreis für Ihr Zielland und einen
        Kilopreis pro angefangenes Kilo.
        <br /> Des Weiteren eine Handlingsgebühr in Höhe von 0,75€ pro Sendung.
        <br /> Ab dem 1. Januar 2027 beträgt die Handlingsgebühr 0,92€ pro Sendung.
        <br />
        <br /> Um Portokosten zu sparen und zu optimieren, möchten wir Ihnen
        gerne empfehlen, in Ihrem Kundenkonto einen Versandtag festzulegen.{' '}
        <br />
        <br />
        <MolLink to="/konto/" href="/konto/">
          Bitte klicken Sie hier um zu Ihrem Kundenkonto zu kommen
        </MolLink>
        <br />
        Wir sammeln die Artikel für Sie und versenden an dem von Ihnen
        gewünschten Tag. Sie zahlen dann nur einmal pro Woche die tatsächlich
        angefallenen Portokosten und die Handlingsgebühr. <br />
        <br /> <b> Portokosten: {this.body.versand.name}</b>
        <br />
        Basesprice {this.body.versand.basis} &euro; + {this.body.versand.kg}{' '}
        &euro; pro Kilogramm
        <br />
        <br />
        Haben Sie eine Lieferadresse in Deutschland? Die Portokosten für eine
        Sendung innerhalb Deutschlands finden Sie{' '}
        <a href="https://www.buchbutler.de/versandkosten" target="_blank">
          hier
        </a>
      </div>
    );
  }
  initState(base: BasePageState): VersandkostenState {
    let newState: VersandkostenState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return (
      this.state.apiBase +
      '/Standard.php?include=versand&land=' +
      (this.body.versand?.alpha2 ?? '')
    );
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Versandkosten';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Versandkosten</span>;
  }
  getType(): string {
    return 'VersandkostenPage';
  }
}
